import { ComponentType } from "react";

import Login from "../views/Auth/Login";
import ForgotPassword from "../views/Auth/ForgotPassword";
import ResetPassword from "../views/Auth/ResetPassword";
import EmailConfirmationError from "../views/Auth/EmailConfirmationError";
import MFASetup from "../views/Auth/MFASetup";
import AuthCodeInput from "../views/Auth/AuthCodeInput";
import NoMatch from "../views/Home/NoMatch";
import Error403 from "../components/UI/Error403";
import SectionNotAvailable from "../components/UI/SectionNotAvailable";
import ComponentTest from "../views/ComponentTest";

import { TrialHomeScreen } from "../views/TrialHomeScreen/TrialHomeScreen";
import Documents from "../views/Documents";
import JulieFeiComponent from "../components/UI/JulieFeiComponent";
import NotificationsHome from "../components/Notifications/NotificationsHome";
import AskVivo from "../views/AskVivo/AskVivo";
const AskVivoForPlanning = AskVivo;
import Alerts from "../views/Alerts/Alerts";
import MedicalReview from "../views/MedicalReview";
import ClinicalReview from "../views/ClinicalReview";
import Insights from "../views/Insights/Insights";
import Roles from "../views/RolesPermissions/Roles";
import FileUpload from "../views/FileUpload/FileUpload";
import SuperuserPanel from "../views/Superuser/SuperuserPanel";
import VivoPlotModal from "../components/VivoPlots/modal";

import SitesMetrics from "../views/Sites/SiteMetrics";
import SingleSiteOverview from "../views/Sites/SingleSite/SingleSiteOverview";
import SiteStartUpMilestones from "../views/Sites/SiteStartUpMilestones";
import ActionItems from "../views/Sites/ActionItems";
import MonitoringSiteVisits from "../views/Sites/MonitoringSiteVisits";
import CrossTrialSiteDirectory from "../views/CrossTrialSiteProfile/CrossTrialSiteDirectory";
import CrossTrialSiteProfile from "../views/CrossTrialSiteProfile/CrossTrialSiteProfile";
import CrossTrialGeoProfile from "../views/CrossTrialSiteProfile/CrossTrialGeoProfile";
import InvestigatorDirectory from "../views/InvestigatorProfile/InvestigatorDirectory";
import InvestigatorProfile from "../views/InvestigatorProfile/InvestigatorProfile";
import InvestigatorGeoProfile from "../views/InvestigatorProfile/InvestigatorGeoProfile";
import DataMasteryAnalytics from "../views/DataMastery/DataMasteryAnalytics";
import DataMasteryQueue from "../views/DataMastery/DataMasteryQueue";
import TrialPlanningList from "../views/TrialPlanning/TrialPlanningList";
import TrialPlanningDetail from "../views/TrialPlanning/TrialPlanningDetail";
import TrialPlanningHome from "../views/TrialPlanning/TrialPlanningHome";
import TrialPlanningSites from "../views/TrialPlanning/TrialPlanningSites";
import TrialPlanningShortlist from "../views/TrialPlanning/TrialPlanningShortlist";
import TrialPlanningScenarios from "../views/TrialPlanning/TrialPlanningScenarios";
import TrialPlanningMilestones from "../views/TrialPlanning/TrialPlanningMilestones";
import TrialPlanningEnrollment from "../views/TrialPlanning/TrialPlanningEnrollment";
import TrialPlanningVendors from "../views/TrialPlanning/TrialPlanningVendors";
import TrialPlanningBudget from "../views/TrialPlanning/TrialPlanningBudget";
import TrialPlanningSiteStartup from "../views/TrialPlanning/TrialPlanningSiteStartup";
import ProtocolDeviations from "../views/Sites/ProtocolDeviations/ProtocolDeviations";
import RegDocsTracker from "../views/Sites/RegDocsTracker/RegDocsTracker";
import Enrollment from "../views/Sites/Enrollment/Enrollment2";
import SiteFeasibilityBoard from "../views/SiteFeasibilityBoard/SiteFeasibilityBoard";
import TrialEnrollment from "@/views/TrialEnrollment/TrialEnrollment";

import Overview from "../views/Subjects/Overview/Overview";
import SingleSubjectOverview from "../views/Subjects/Overview/SingleSubjectOverview";
import SubjectVisitsActivities from "../views/Subjects/Activities/SubjectVisitsActivities";
import AllSubjects from "../views/Subjects/All";

import IpAdministration from "../views/Safety/IpAdministration";
import IpDispensation from "../views/Safety/IpDispensation";
import Pharmacokinetics from "../views/Safety/Pharmacokinetics/Pharmacokinetics";
import AdverseEvents from "../views/Safety/AdverseEvents";
import ConcomitantMedications from "../views/Safety/ConcomitantMedications";
import ConcomitantProcedures from "../views/Safety/ConcomitantProcedures";
import DosingTracker from "../views/Safety/DosingTracker/DosingTracker";

import Labs from "../views/Measures/Labs";
import Questionnaires from "../views/Measures/Questionnaires";
import Assessment from "../views/Measures/Assessment";
import AdministrativeFormRecords from "../views/Measures/AdministrativeFormRecords";
import Imaging from "../views/Measures/Imaging";
import ImagingViewerCT from "../views/Measures/ImagingViewerCT";
import ImagingViewerEndoscopy from "../views/Measures/ImagingViewerEndoscopy";
import ECG from "../views/Measures/ECG";
import ImagingStudies from "../views/Measures/ImagingStudies";
import ImagingReads from "../views/Measures/ImagingReads";
import ImagingOperations from "../views/Measures/ImagingOperations";
import Spirometry from "../views/Measures/Spirometry";
import TumorResponse from "../views/Analysis/TumorResponse";
import Biomarkers from "../views/Analysis/Biomarkers";
import AnalysisPharmacokinetics from "../views/Analysis/Pharmacokinetics";
import Immunogenicity from "../views/Analysis/Immunogenicity";
import EcgVisitTrends from "../views/Measures/EcgVisitTrends";

import {
  LogisticsMaterials,
  LogisticsLots,
  LogisticsLocations,
  LogisticsUnits,
  LogisticsShipments,
  LogisticsShipmentItems,
  LogisticsInventory,
  LogisticsReconciliation,
  LogisticsEvents,
} from "../views/Logistics";

import Connections from "../views/Data/Connections";
import TrialDefinitionsPage from "../views/Definitions/TrialDefinitionsPage";
import DataDiscrepancies from "../views/DataDiscrepancies/index";
import TrialIssues from "@/views/Data/TrialIssues/TrialIssues";
import StudyDesign from "../views/Data/StudyDesign";
import AuditTrail from "../views/Data/AuditTrail";
import TrialContactList from "../views/TrialContactList/TrialContactList";

import WikiHome from "../views/Wiki/WikiHome";
import WikiPage from "../views/Wiki/WikiPage";

import PortfolioTrials from "../views/PortfolioTrials/PortfolioTrials";
import PortfolioMetricRedirect from "../views/PortfolioTrials/PortfolioMetricRedirect";
import PortfolioTrialDetailView from "../views/PortfolioTrials/PortfolioTrialDetailView";
import PortfolioConnections from "../views/PortfolioConnections/PortfolioConnections";
import ExternalEvidence from "../views/ExternalEvidence/ExternalEvidence";

import { FEATURE_FLAGS } from "../utils/feature-flag-constants";
import Risks from "@/views/Risk/Risks/Risks";
import Signals from "@/views/Risk/Signals/Signals";
import Breaches from "@/views/Risk/Breaches/Breaches";
import Tasks from "@/views/Risk/Tasks/Tasks";
import Actions from "@/views/Actions/Actions";
import RiskAnalytics from "@/views/Risk/Analytics/RiskAnalytics";
import AdminLandingRedirect from "@/views/Admin/AdminLandingRedirect";
import {
  AdminActivityLogPage,
  AdminRolesPermissionsPage,
  AdminUsersAccessPage,
} from "@/views/Admin/AdminPages";

import PlanOfRecord from "../views/PlanOfRecord/PlanOfRecord";
import DocumentWorkspace from "../views/DocumentWorkspace/DocumentWorkspace";

export interface RouteConfig {
  path?: string;
  index?: boolean;
  component?: ComponentType;
  featureFlag?: string | string[];
  /**
   * Inverse of `featureFlag`: the route is reachable *unless* one of these
   * flags is granted. For screens a tenant should not reach because their feed
   * leaves them empty — removing the links is not enough while the URL still
   * works. Honoured by `renderRoute` via `FeatureFlagBlock`.
   */
  blockedByFeatureFlag?: string | string[];
  goToNotFound?: boolean;
  /** Adds a <Route path="*" element={null} /> child (needed by SingleSubjectOverview) */
  wildcardChild?: boolean;
  children?: RouteConfig[];
  /** Ask Vivo metadata for this route */
  askVivo?: import("../components/AskVivo/askVivo.types").AskVivoRouteMeta;
}

export const publicRoutes: RouteConfig[] = [
  { path: "/404", component: SectionNotAvailable },
  { path: "/login", component: Login },
  { path: "/forgot", component: ForgotPassword },
  { path: "/reset", component: ResetPassword },
  { path: "/email-confirmation-error", component: EmailConfirmationError },
  { path: "/mfa-setup", component: MFASetup as ComponentType },
  { path: "/mfa-code", component: AuthCodeInput as ComponentType },
  { path: "/component-test", component: ComponentTest },
  { path: "/403", component: Error403 },
  { path: "*", component: NoMatch },
];

export const portfolioRoutes: RouteConfig[] = [
  // Portfolio is mounted at a bare "/portfolio" with no :id segment, so
  // buildUrl("404") yields "/portfolio/404" — two segments, which never matches
  // App's "/:scope/:id/404". Without this the gate redirects land on the
  // generic ErrorPage ("Something went wrong"), dressing an entitlement
  // decision up as a malfunction. adminRoutes carries the same entry.
  { path: "404", component: SectionNotAvailable },
  {
    path: "data/external/:dataset",
    component: ExternalEvidence,
    featureFlag: FEATURE_FLAGS.EXTERNAL_EVIDENCE,
    goToNotFound: true,
  },
  {
    path: "evidence/:dataset",
    component: ExternalEvidence,
    featureFlag: FEATURE_FLAGS.EXTERNAL_EVIDENCE,
    goToNotFound: true,
  },
  {
    path: "trials",
    component: PortfolioTrials,
  },
  {
    path: "askvivo",
    component: AskVivo,
    featureFlag: FEATURE_FLAGS.PORT_ASKVIVO,
    goToNotFound: true,
  },
  {
    path: "enrollment",
    component: PortfolioMetricRedirect,
    featureFlag: FEATURE_FLAGS.PORT_ENROLLMENT,
    goToNotFound: true,
  },
  {
    path: "retention",
    component: PortfolioMetricRedirect,
    featureFlag: FEATURE_FLAGS.PORT_RETENTION,
    goToNotFound: true,
  },
  {
    path: "milestones",
    component: PortfolioMetricRedirect,
    featureFlag: FEATURE_FLAGS.PORT_MILESTONES,
    goToNotFound: true,
  },
  {
    path: "safety",
    component: PortfolioMetricRedirect,
    featureFlag: FEATURE_FLAGS.PORT_SAFETY,
    goToNotFound: true,
  },
  {
    path: "compliance",
    component: PortfolioMetricRedirect,
    featureFlag: FEATURE_FLAGS.PORT_COMPLIANCE,
    goToNotFound: true,
  },
  {
    path: "site-profiles",
    component: CrossTrialSiteDirectory,
    featureFlag: FEATURE_FLAGS.PORT_SITE_PROFILES,
    goToNotFound: true,
  },
  {
    path: "site-profiles/:siteKey",
    component: CrossTrialSiteProfile,
    featureFlag: FEATURE_FLAGS.PORT_SITE_PROFILES,
    blockedByFeatureFlag: FEATURE_FLAGS.SITE_PROFILE_LINKS_HIDDEN,
    goToNotFound: true,
  },
  {
    path: "site-profiles/:siteKey/:tab",
    component: CrossTrialSiteProfile,
    featureFlag: FEATURE_FLAGS.PORT_SITE_PROFILES,
    blockedByFeatureFlag: FEATURE_FLAGS.SITE_PROFILE_LINKS_HIDDEN,
    goToNotFound: true,
  },
  {
    path: "site-profiles/geo/:geoType/:geoValue",
    component: CrossTrialGeoProfile,
    featureFlag: FEATURE_FLAGS.PORT_SITE_PROFILES,
    goToNotFound: true,
  },
  {
    path: "site-profiles/geo/:geoType/:geoValue/:tab",
    component: CrossTrialGeoProfile,
    featureFlag: FEATURE_FLAGS.PORT_SITE_PROFILES,
    goToNotFound: true,
  },
  {
    path: "investigators/geo/:geoType/:geoValue",
    component: InvestigatorGeoProfile,
    featureFlag: FEATURE_FLAGS.PORT_INVESTIGATORS,
    goToNotFound: true,
  },
  {
    path: "investigators",
    component: InvestigatorDirectory,
    featureFlag: FEATURE_FLAGS.PORT_INVESTIGATORS,
    goToNotFound: true,
  },
  {
    path: "investigators/:invKey",
    component: InvestigatorProfile,
    featureFlag: FEATURE_FLAGS.PORT_INVESTIGATORS,
    blockedByFeatureFlag: FEATURE_FLAGS.INVESTIGATOR_PROFILE_LINKS_HIDDEN,
    goToNotFound: true,
  },
  {
    path: "investigators/:invKey/:tab",
    component: InvestigatorProfile,
    featureFlag: FEATURE_FLAGS.PORT_INVESTIGATORS,
    blockedByFeatureFlag: FEATURE_FLAGS.INVESTIGATOR_PROFILE_LINKS_HIDDEN,
    goToNotFound: true,
  },
  {
    path: "trials/:trialId",
    component: PortfolioTrialDetailView,
  },
  {
    path: "trials/:trialId/:tab",
    component: PortfolioTrialDetailView,
  },
  {
    // Analytics-first: the mastery landing page is the analytics surface; the
    // review queue is the stewards' own interface behind its header button.
    path: "data/mastery",
    component: DataMasteryAnalytics,
  },
  {
    path: "data/mastery/queue",
    component: DataMasteryQueue,
  },
  {
    path: "data/connections",
    component: PortfolioConnections,
  },
  {
    // Trial planning list embedded at portfolio level: same navbar, plan
    // content in the body. Opening a plan enters the planning shell.
    path: "planning",
    component: TrialPlanningList,
  },
];

export const planningRoutes: RouteConfig[] = [
  { index: true, component: TrialPlanningList },
  {
    path: ":planId",
    component: TrialPlanningDetail,
    children: [
      { path: "home", component: TrialPlanningHome },
      { path: "scenarios", component: TrialPlanningScenarios },
      { path: "shortlist", component: TrialPlanningShortlist },
      { path: "sites", component: TrialPlanningSites },
      { path: "siteplan", component: TrialPlanningSiteStartup },
      { path: "milestones", component: TrialPlanningMilestones },
      { path: "enrollment", component: TrialPlanningEnrollment },
      { path: "vendors", component: TrialPlanningVendors },
      { path: "budget", component: TrialPlanningBudget },
      { path: "askvivo", component: AskVivoForPlanning },
    ],
  },
];

export const adminRoutes: RouteConfig[] = [
  { index: true, component: AdminLandingRedirect },
  { path: "404", component: SectionNotAvailable },
  {
    path: "users-access",
    component: AdminUsersAccessPage,
  },
  {
    path: "roles-permissions",
    component: AdminRolesPermissionsPage,
  },
  {
    path: "activity-log",
    component: AdminActivityLogPage,
  },
];

export const trialRoutes: RouteConfig[] = [
  {
    path: "home",
    component: TrialHomeScreen,
    featureFlag: FEATURE_FLAGS.TRIAL_HOME_SCREEN,
  },
  {
    path: "plan",
    children: [
      {
        path: "study-documents",
        component: DocumentWorkspace,
        featureFlag: FEATURE_FLAGS.STUDY_DOCUMENT_WORKSPACE,
        goToNotFound: true,
      },
      {
        path: "milestones",
        component: PlanOfRecord,
        featureFlag: FEATURE_FLAGS.PLAN_OF_RECORD,
        goToNotFound: true,
      },
      {
        path: "enrollment",
        component: TrialEnrollment,
        featureFlag: FEATURE_FLAGS.TRIAL_ENROLLMENT,
        goToNotFound: true,
      },
    ],
  },
  {
    path: "documents",
    component: Documents,
    featureFlag: FEATURE_FLAGS.DOCUMENTS,
    goToNotFound: true,
  },
  {
    path: "sulie",
    component: JulieFeiComponent,
  },
  {
    path: "notifications",
    component: NotificationsHome,
    featureFlag: FEATURE_FLAGS.COMPONENT_NOTIFICATIONS,
    goToNotFound: true,
  },
  {
    path: "askvivo",
    component: AskVivo,
    featureFlag: FEATURE_FLAGS.ASKVIVO,
    goToNotFound: true,
  },
  {
    path: "alerts",
    component: Alerts,
    featureFlag: FEATURE_FLAGS.ALERTS,
    goToNotFound: true,
  },
  {
    path: "trial-contact-list",
    component: TrialContactList,
    featureFlag: FEATURE_FLAGS.TRIAL_CONTACT_LIST,
    goToNotFound: true,
  },
  {
    path: "sites/site-feasibility-board",
    component: SiteFeasibilityBoard,
    featureFlag: FEATURE_FLAGS.SITE_FEASIBILITY_BOARD,
    goToNotFound: true,
  },
  {
    path: "insights",
    component: Insights,
    featureFlag: FEATURE_FLAGS.INSIGHTS,
    goToNotFound: true,
  },
  {
    path: "actions",
    component: Actions,
    featureFlag: FEATURE_FLAGS.ACTIONS,
    goToNotFound: true,
  },
  {
    path: "roles",
    component: Roles,
    featureFlag: FEATURE_FLAGS.ROLES,
    goToNotFound: true,
  },
  {
    path: "file-upload",
    component: FileUpload,
    featureFlag: FEATURE_FLAGS.FILE_UPLOAD,
    goToNotFound: true,
  },
  {
    path: "superuser",
    component: SuperuserPanel,
  },

  {
    path: "vivo-plot/modal",
    component: VivoPlotModal,
  },
  {
    path: "sites",
    children: [
      {
        path: "overview",
        component: SitesMetrics,
        featureFlag: FEATURE_FLAGS.SITES_OVERVIEW,
        goToNotFound: true,
      },
      {
        path: "enrollment",
        component: Enrollment,
        featureFlag: FEATURE_FLAGS.FORECASTING,
        goToNotFound: true,
      },
      {
        path: "profile/:siteId/*",
        component: SingleSiteOverview,
        featureFlag: FEATURE_FLAGS.SITES_OVERVIEW,
        blockedByFeatureFlag: FEATURE_FLAGS.TRIAL_SITE_PROFILE_LINKS_HIDDEN,
        goToNotFound: true,
      },
      {
        path: "monitoring-site-visits",
        component: MonitoringSiteVisits,
        featureFlag: FEATURE_FLAGS.SITE_MONITORING_VISITS,
        goToNotFound: true,
      },
      {
        path: "action-items",
        component: ActionItems,
        featureFlag: FEATURE_FLAGS.CTMS_ACTION_ITEM,
        goToNotFound: true,
      },
      {
        path: "site-start-up-milestones",
        component: SiteStartUpMilestones,
        featureFlag: FEATURE_FLAGS.SITE_ACTIVATION_MILESTONE,
        goToNotFound: true,
      },
      {
        path: "protocol-deviations",
        component: ProtocolDeviations,
        featureFlag: FEATURE_FLAGS.PROTOCOL_DEVIATIONS,
        goToNotFound: true,
      },
      {
        path: "reg-docs-tracker",
        component: RegDocsTracker,
        featureFlag: FEATURE_FLAGS.REG_DOCS_TRACKER,
        goToNotFound: true,
      },
    ],
  },
  {
    path: "subjects",
    children: [
      {
        path: "overview",
        component: Overview,
        featureFlag: FEATURE_FLAGS.SUBJECTS_OVERVIEW,
        goToNotFound: true,
      },
      {
        path: "overview/:subjectId",
        component: SingleSubjectOverview,
        featureFlag: FEATURE_FLAGS.SUBJECTS_OVERVIEW,
        goToNotFound: true,
        wildcardChild: true,
      },
      {
        path: "visits-activities",
        component: SubjectVisitsActivities,
        featureFlag: FEATURE_FLAGS.VISITS_ACTIVITIES,
        goToNotFound: true,
      },
      {
        path: "all-subjects",
        component: AllSubjects,
        featureFlag: (FEATURE_FLAGS as any).ALL_SUBJECTS,
        goToNotFound: true,
      },
    ],
  },
  {
    path: "safety",
    children: [
      {
        path: "medical-review",
        component: MedicalReview,
        featureFlag: FEATURE_FLAGS.MEDICAL_REVIEW,
        goToNotFound: true,
      },
      {
        path: "ip-administration",
        component: IpAdministration,
        featureFlag: FEATURE_FLAGS.IP_ADMINISTRATION,
        goToNotFound: true,
      },
      {
        path: "ip-dispensation",
        component: IpDispensation,
        featureFlag: FEATURE_FLAGS.IP_DISPENSATION,
        goToNotFound: true,
      },
      {
        path: "pharmacokinetics",
        component: Pharmacokinetics,
        featureFlag: FEATURE_FLAGS.PHARMACOKINETICS,
        goToNotFound: true,
      },
      {
        path: "adverse-events",
        component: AdverseEvents,
        featureFlag: FEATURE_FLAGS.ADVERSE_EVENTS,
        goToNotFound: true,
      },
      {
        path: "concomitant-medications",
        component: ConcomitantMedications,
        featureFlag: FEATURE_FLAGS.CONMEDS,
        goToNotFound: true,
      },
      {
        path: "concomitant-procedures",
        component: ConcomitantProcedures,
        featureFlag: FEATURE_FLAGS.CONCOMITANT_PROCEDURES,
        goToNotFound: true,
      },
      {
        path: "dosing-tracker",
        component: DosingTracker,
        featureFlag: FEATURE_FLAGS.DOSING_TRACKER,
        goToNotFound: true,
      },
    ],
  },
  {
    path: "measures",
    children: [
      {
        path: "labs",
        component: Labs,
        featureFlag: FEATURE_FLAGS.LABS,
        goToNotFound: true,
      },
      {
        path: "questionnaires",
        component: Questionnaires,
        featureFlag: FEATURE_FLAGS.EFFICACY_MEASURE,
        goToNotFound: true,
      },
      {
        path: "administrative-form-records",
        component: AdministrativeFormRecords,
        featureFlag: FEATURE_FLAGS.ADMINISTRATIVE_FORM_RECORDS,
        goToNotFound: true,
      },
      {
        path: "assessments",
        component: Assessment,
        featureFlag: FEATURE_FLAGS.SAFETY_MEASURES,
        goToNotFound: true,
      },
      {
        // The standard CRF Imaging measures screen. DICOM-viewer tenants get
        // the modality-scoped CT/Endoscopy screens below instead — there is no
        // longer a combined CT+Endoscopy list, since the two have nothing in
        // common to browse together.
        path: "imaging",
        component: Imaging,
        featureFlag: FEATURE_FLAGS.IMAGING,
        goToNotFound: true,
      },
      {
        // CT and Endoscopy have nothing in common to browse together
        // (radiology slices vs. video captures), so imaging-viewer tenants get
        // one screen per modality instead of one combined "Imaging" list.
        path: "imaging-ct",
        component: ImagingViewerCT,
        featureFlag: FEATURE_FLAGS.IMAGING_VIEWER,
        goToNotFound: true,
      },
      {
        path: "imaging-endoscopy",
        component: ImagingViewerEndoscopy,
        featureFlag: FEATURE_FLAGS.IMAGING_VIEWER,
        goToNotFound: true,
      },
      {
        // ECG's own home: numeric interval table (ecg_intervals) + an ECG Trends
        // waveform view. Gated by the dedicated ECG flag so it is independent of
        // Assessments (safety-measures) and of the radiology imaging screens.
        path: "ecg",
        component: ECG,
        featureFlag: FEATURE_FLAGS.ECG,
        goToNotFound: true,
      },
      {
        path: "imaging-studies",
        component: ImagingStudies,
        featureFlag: FEATURE_FLAGS.IMAGING_STUDIES,
        goToNotFound: true,
      },
      {
        path: "imaging-reads",
        component: ImagingReads,
        featureFlag: FEATURE_FLAGS.CLARIO_IMAGING_WORKFLOW,
        goToNotFound: true,
      },
      {
        path: "imaging-operations",
        component: ImagingOperations,
        featureFlag: FEATURE_FLAGS.CLARIO_IMAGING_WORKFLOW,
        goToNotFound: true,
      },
      {
        path: "spirometry",
        component: Spirometry,
        featureFlag: FEATURE_FLAGS.WAVEFORMS,
        goToNotFound: true,
      },
      {
        path: "ecg-trends",
        component: EcgVisitTrends,
        featureFlag: FEATURE_FLAGS.WAVEFORMS,
        goToNotFound: true,
      },
      {
        // Clinical Data Review reviews COA/PRO responses (questionnaires,
        // above) and quantitative assessments (assessments, above) for
        // scientific plausibility — grouped with the measurement data it
        // reviews rather than under Safety (a different reviewer's question)
        // or Data (data-management/completeness, which this explicitly is
        // not — see the PRD's problem statement).
        path: "clinical-review",
        component: ClinicalReview,
        featureFlag: FEATURE_FLAGS.CLINICAL_DATA_REVIEW,
        goToNotFound: true,
      },
    ],
  },
  {
    // Phase-B oncology "Analysis" section — merged from four slices. No parent
    // flag; each child gates on its own flag (goToNotFound redirects if off).
    path: "analysis",
    children: [
      {
        path: "tumor-response",
        component: TumorResponse,
        featureFlag: FEATURE_FLAGS.TUMOR_RESPONSE,
        goToNotFound: true,
      },
      {
        path: "biomarkers",
        component: Biomarkers,
        featureFlag: FEATURE_FLAGS.BIOMARKERS,
        goToNotFound: true,
      },
      {
        path: "pharmacokinetics",
        component: AnalysisPharmacokinetics,
        featureFlag: FEATURE_FLAGS.PHARMACOKINETICS,
        goToNotFound: true,
      },
      {
        path: "immunogenicity",
        component: Immunogenicity,
        featureFlag: FEATURE_FLAGS.IMMUNOGENICITY,
        goToNotFound: true,
      },
    ],
  },
  {
    path: "risk",
    featureFlag: FEATURE_FLAGS.RISKS,
    children: [
      {
        path: "risks",
        component: Risks,
        featureFlag: FEATURE_FLAGS.RISKS,
        goToNotFound: true,
      },
      {
        path: "signals",
        component: Signals,
        featureFlag: FEATURE_FLAGS.RISKS,
        goToNotFound: true,
      },
      {
        path: "issues",
        component: Breaches,
        featureFlag: FEATURE_FLAGS.RISKS,
        goToNotFound: true,
      },
      {
        path: "tasks",
        component: Tasks,
        featureFlag: FEATURE_FLAGS.RISKS,
        goToNotFound: true,
      },
      {
        path: "analytics",
        component: RiskAnalytics,
        featureFlag: FEATURE_FLAGS.RISKS,
        goToNotFound: true,
      },
    ],
  },
  {
    path: "data",
    children: [
      {
        path: "configuration",
        component: Connections,
        featureFlag: FEATURE_FLAGS.DATA_CONNECTIONS,
        goToNotFound: true,
      },
      {
        path: "definitions",
        component: TrialDefinitionsPage,
        featureFlag: FEATURE_FLAGS.TRIAL_DEFINITIONS,
        goToNotFound: true,
      },
      {
        path: "discrepancies",
        component: DataDiscrepancies as ComponentType,
        featureFlag: FEATURE_FLAGS.DATA_DISCREPANCIES,
        goToNotFound: true,
      },
      {
        path: "trial-issues",
        component: TrialIssues,
        featureFlag: FEATURE_FLAGS.TRIAL_ISSUES,
        goToNotFound: true,
      },
      {
        path: "study-design",
        component: StudyDesign,
        featureFlag: FEATURE_FLAGS.STUDY_DESIGN,
        goToNotFound: true,
      },
      {
        path: "audit-trail",
        component: AuditTrail,
        featureFlag: FEATURE_FLAGS.SOURCE_AUDIT,
        goToNotFound: true,
      },
    ],
  },
  {
    path: "logistics",
    featureFlag: FEATURE_FLAGS.LOGISTICS,
    children: [
      {
        path: "materials",
        component: LogisticsMaterials,
        featureFlag: FEATURE_FLAGS.LOGISTICS_MATERIALS,
        goToNotFound: true,
      },
      {
        path: "lots",
        component: LogisticsLots,
        featureFlag: FEATURE_FLAGS.LOGISTICS_LOTS,
        goToNotFound: true,
      },
      {
        path: "locations",
        component: LogisticsLocations,
        featureFlag: FEATURE_FLAGS.LOGISTICS_LOCATIONS,
        goToNotFound: true,
      },
      {
        path: "units",
        component: LogisticsUnits,
        featureFlag: FEATURE_FLAGS.LOGISTICS_UNITS,
        goToNotFound: true,
      },
      {
        path: "shipments",
        component: LogisticsShipments,
        featureFlag: FEATURE_FLAGS.LOGISTICS_SHIPMENTS,
        goToNotFound: true,
      },
      {
        path: "shipment-items",
        component: LogisticsShipmentItems,
        featureFlag: FEATURE_FLAGS.LOGISTICS_SHIPMENT_ITEMS,
        goToNotFound: true,
      },
      {
        path: "inventory",
        component: LogisticsInventory,
        featureFlag: FEATURE_FLAGS.LOGISTICS_INVENTORY,
        goToNotFound: true,
      },
      {
        path: "reconciliation",
        component: LogisticsReconciliation,
        featureFlag: FEATURE_FLAGS.LOGISTICS_RECONCILIATION,
        goToNotFound: true,
      },
      {
        path: "events",
        component: LogisticsEvents,
        featureFlag: FEATURE_FLAGS.LOGISTICS_EVENTS,
        goToNotFound: true,
      },
    ],
  },
];

export const wikiRoutes: RouteConfig[] = [
  { index: true, component: WikiHome },
  { path: ":type/:slug", component: WikiPage },
];
